(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("keen-core"));
	else if(typeof define === 'function' && define.amd)
		define(["keen-core"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("keen-core")) : factory(root["keen-core"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function(__WEBPACK_EXTERNAL_MODULE__12__) {
return 